<i
  class="pi pi-star mx-3 my-3 text-xl cursor-pointer p-text-secondary"
  (click)="op.toggle($event); diff = 0"
  pTooltip="Избранные"
  tooltipPosition="top"
  tooltipStyleClass="p-n-tooltip"
  [showDelay]="200"
  [life]="1000">
</i>

<p-overlayPanel
  #op
  [style]="{ width: '400px' }"
  styleClass="dropdown-overlay-panel informer-overlay-panel"
  (onShow)="loadNotifications()"
  (onHide)="queryParams.offset = 0">
  <ng-template pTemplate="">
    <div
      class="flex justify-content-between py-2 text-white border-round-top-md"
      style="background: #23538c">
      <div class="flex align-items-center">
        <button
          pButton
          type="button"
          icon="pi pi-refresh"
          class="p-button-rounded text-white p-button-text mx-1"
          (click)="queryParams.offset = 0; loadNotifications()"></button>
        <p class="font-bold">Избранное</p>
      </div>
    </div>

    <ng-container *ngIf="loading; else notificationsTemplate">
      <crm-spinner top="mt-3"></crm-spinner>
    </ng-container>
    <ng-template #notificationsTemplate>
      <div
        class="overflow-y-auto"
        (scroll)="onScrollEnd($any($event.target))"
        style="height: 400px">
        <ng-container *ngIf="(notifications | keyValueFilter: { type: FavoriteInformerTypeEnum.PROJECT })?.length">
          <div
            class="flex h-3rem px-3 py-2 align-items-center justify-content-between text-gray-500 font-bold border-top-1 border-bottom-1 border-gray-200">
            <p>Задачи</p>
            <div>
              <a
                class="flex align-items-center justify-content-between gap-2 font-normal"
                (click)="op.hide()"
                routerLink="/project/list"
                [queryParams]="{
                  onlyFavorites: true,
                  participantKind: ProjectKindEnum.ALL,
                  listStyle: 'flat'
                }">
                <i class="pi pi-window-maximize"></i>
                Подробнее
              </a>
            </div>
          </div>
          <div
            *ngFor="let project of notifications | keyValueFilter: { type: FavoriteInformerTypeEnum.PROJECT }"
            class="border-bottom-1 border-gray-200">
            <div class="flex px-3 py-2 gap-2 justify-content-between align-items-center">
              <a
                routerLink="/project/card/{{ project.id }}"
                [class.font-bold]="project.status?.type === ProjectStatusTypeEnum.THEME"
                [ngStyle]="{ color: project.status.color }"
                [pTooltip]="project.status ? project.status.name : null"
                tooltipPosition="right"
                (click)="op.hide()">
                {{ project.name }}
              </a>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="(notifications | keyValueFilter: { type: FavoriteInformerTypeEnum.HD_TASK })?.length">
          <div
            class="flex h-3rem px-3 py-2 align-items-center justify-content-between text-gray-500 font-bold border-bottom-1 border-gray-200">
            <p>Заявки HelpDesk</p>
            <div>
              <a
                class="flex align-items-center justify-content-between gap-2 font-normal"
                (click)="op.hide()"
                routerLink="/helpdesk/task"
                [queryParams]="
                  {
                    onlyFavorites: true,
                    finishDate: false
                  } | concatDateParams: 'year'
                ">
                <i class="pi pi-window-maximize"></i>
                Подробнее
              </a>
            </div>
          </div>
          <crm-table
            *ngIf="notifications?.length"
            [values]="notifications | keyValueFilter: { type: FavoriteInformerTypeEnum.HD_TASK }"
            [columns]="[]"
            styleClass="p-datatable-sm">
            <ng-template
              #rowTemplate
              let-task="item">
              <tr>
                <td>
                  <a
                    routerLink="/helpdesk/task/card/{{ task.id }}"
                    [ngStyle]="{ color: task.status.color }"
                    [pTooltip]="task.status ? task.status.name : null"
                    (click)="op.hide()">
                    {{ task.id }}
                  </a>
                </td>
                <td>
                  <a [routerLink]="task.client?.id ? ['/client/client/card/', task.client?.id] : null">
                    {{ task.client?.name || 'Неизвестно' }}
                  </a>
                </td>
                <td>
                  <p [innerHTML]="getText(task.description) | truncate: 20"></p>
                </td>
              </tr>
            </ng-template>
          </crm-table>
        </ng-container>
        <div
          *ngIf="paginationLoading"
          class="text-center">
          <p-progressSpinner
            [style]="{
              width: '50px',
              height: '50px'
            }"></p-progressSpinner>
        </div>

        <div *ngIf="!notifications?.length">
          <crm-no-data [size]="NoDataSize"></crm-no-data>
          <h4 class="font-normal text-center">Нет избранных</h4>
        </div>
      </div>
    </ng-template>
  </ng-template>
</p-overlayPanel>
